export default "__VITE_ASSET__zGbREIqd__"